module.exports = __webpack_public_path__ + "html5-icon.svg?e1fe015cbbb933f7a5ce5780cee2486f";


//////////////////
// WEBPACK FOOTER
// ./src/assets/skill-icons/html5-icon.svg
// module id = 48
// module chunks = 0